import Header from './Header'
const Verificationthank = () => {
    return (
        <div className="best">
            <Header />
            <div className="bredcrub">
            <div className="container">
                <ul>
                    <li><a href="#">Home</a></li>
                    <li>Register</li>
                </ul>
            </div>
        </div>

        <div className="verifybox">
            <h2>Thankyou for Varification</h2>
            <p>You can create a password if you wish to, otherwise you<br/> must sign in by requesting an OTP each time.
            </p>
            <button>Create Password</button>
            <p className="verifybottominfo"><a href="">Skip to Dashboard</a></p>
        </div>

        </div>
    );
};
  
export default Verificationthank;